import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import { EXHIBITION_IMAGES } from "@/data/content";
import { useT, useLang } from "@/i18n";

function ImprintEN() {
  return (
    <div className="mt-12 space-y-8 text-base leading-relaxed text-black">
      <div>
        <p className="font-bold text-lg">Artful Events Europe GmbH</p>
        <p className="mt-2">Represented by the general manager Deniz Türkan</p>
      </div>
      <div>
        <p>Anton-Kux-Str. 2</p>
        <p>41460 Neuss</p>
        <p>Germany</p>
      </div>
      <div>
        <p><span className="text-[#C20E1A] font-bold">Telephone:</span> 02131-3134985</p>
        <p><span className="text-[#C20E1A] font-bold">Telefax:</span> 02131-3134987</p>
        <p>
          <span className="text-[#C20E1A] font-bold">E-Mail:</span>{" "}
          <a href="mailto:info@artful-events.de" className="link-red" data-testid="imprint-email">
            info@artful-events.de
          </a>
        </p>
        <p className="mt-2"><span className="text-[#C20E1A] font-bold">VAT No.:</span> DE 360432406</p>
      </div>
      <div>
        <p>Listed in the commercial register of the local court Neuss</p>
        <p>Commercial register number – Part B of the commercial register – 22940</p>
      </div>
      <div className="pt-6 border-t border-black/10">
        <p className="font-bold text-black">
          Contact point pursuant to Regulation (EU) 2021/784 of the European Parliament and of the Council:
        </p>
        <p className="mt-2">E-mail:</p>
        <p>Contact is possible in the following languages:</p>
      </div>
      <div>
        <p className="font-bold text-black">
          Contact point for users and authorities in accordance with Regulation (EU) 2022/2065 of the European Parliament and of the Council:
        </p>
        <p className="mt-2">E-mail:</p>
        <p>Contact is possible in the following languages:</p>
      </div>
      <div className="pt-6 border-t border-black/10">
        <p>
          We are neither willing nor obliged to participate in dispute resolution proceedings before consumer arbitration boards.
        </p>
      </div>
      <div>
        <p>We are a member of the initiative &bdquo;FairCommerce&ldquo; since 16.11.2015.</p>
        <p className="mt-2">
          For more information, see:{" "}
          <a
            href="https://www.haendlerbund.de/faircommerce"
            target="_blank"
            rel="noopener noreferrer"
            className="link-red"
            data-testid="imprint-faircommerce"
          >
            www.haendlerbund.de/faircommerce
          </a>
          .
        </p>
      </div>
    </div>
  );
}

function ImprintDE() {
  return (
    <div className="mt-12 space-y-8 text-base leading-relaxed text-black">
      <div>
        <p className="font-bold text-lg">Artful Events Europe GmbH</p>
        <p className="mt-2">diese vertr. d. d. Geschäftsführer Deniz Türkan</p>
      </div>
      <div>
        <p>Anton-Kux-Str. 2</p>
        <p>41460 Neuss</p>
        <p>Deutschland</p>
      </div>
      <div>
        <p><span className="text-[#C20E1A] font-bold">Telefon:</span> 02131-3134985</p>
        <p><span className="text-[#C20E1A] font-bold">Telefax:</span> 02131-3134987</p>
        <p>
          <span className="text-[#C20E1A] font-bold">E-Mail:</span>{" "}
          <a href="mailto:info@artful-events.de" className="link-red" data-testid="imprint-email">
            info@artful-events.de
          </a>
        </p>
      </div>
      <div>
        <p><span className="text-[#C20E1A] font-bold">USt-IdNr.:</span> DE 360432406</p>
        <p className="mt-2">eingetragen im Handelsregister des Amtsgerichtes Neuss</p>
        <p>Handelsregisternummer HRB 22940</p>
      </div>
      <div className="pt-6 border-t border-black/10">
        <p className="font-bold text-black">
          Kontaktstelle gemäß Verordnung (EU) 2021/784 des Europäischen Parlaments und des Rates:
        </p>
        <p className="mt-2">E-Mail:</p>
        <p>Eine Kontaktaufnahme ist in folgenden Sprachen möglich:</p>
      </div>
      <div>
        <p className="font-bold text-black">
          Kontaktstelle für Nutzer und Behörden gemäß Verordnung (EU) 2022/2065 des Europäischen Parlaments und des Rates:
        </p>
        <p className="mt-2">E-Mail:</p>
        <p>Eine Kontaktaufnahme ist in folgenden Sprachen möglich:</p>
      </div>
      <div className="pt-6 border-t border-black/10">
        <p>
          Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor
          Verbraucherschlichtungsstellen teilzunehmen.
        </p>
      </div>
      <div>
        <p>Wir sind seit 16.11.2015 Mitglied der Initiative &bdquo;FairCommerce&ldquo;.</p>
        <p className="mt-2">
          Nähere Informationen hierzu finden Sie unter{" "}
          <a
            href="https://www.haendlerbund.de/faircommerce"
            target="_blank"
            rel="noopener noreferrer"
            className="link-red"
            data-testid="imprint-faircommerce"
          >
            www.haendlerbund.de/faircommerce
          </a>
          .
        </p>
      </div>
    </div>
  );
}

export default function Imprint() {
  const t = useT();
  const { lang } = useLang();
  const isDe = lang === "de";
  return (
    <div data-testid="imprint-page" className="bg-white">
      <PageHero
        eyebrow={t.pages.imprint.eyebrow}
        title={t.pages.imprint.title}
        subtitle={t.pages.imprint.subtitle}
        image={EXHIBITION_IMAGES[2]}
      />
      <section className="py-24 md:py-32">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 lg:px-14">
          <Reveal>
            <p className="eyebrow">{t.pages.imprint.title}</p>
            <h2 className="heading-display mt-3 text-3xl sm:text-4xl uppercase text-black">
              {isDe ? (
                <>Gesetzliche <span className="text-[#C20E1A]">Anbieterkennung</span></>
              ) : (
                <>Legal website operator <span className="text-[#C20E1A]">identification</span></>
              )}
            </h2>
          </Reveal>
          <Reveal delay={80}>{isDe ? <ImprintDE /> : <ImprintEN />}</Reveal>
        </div>
      </section>
    </div>
  );
}
